import TeamPhotoFeed from './TeamPhotoFeed'

export default TeamPhotoFeed
